export default {
  isDev: process.env.NODE_ENV === "development",
  isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
  numberErrorText: "Numero di carta non valido",
  cvvErrorText: "Numero non valido",
  expirationDateErrorText: "Data non valida",
};
